import {getDynamicLink} from './getDynamicLink'

export const firebase = {
  getDynamicLink,
}
